// Drops repeated rows, keeping the first of each. Rows count as the same when
// they serialise the same. Each row is serialised once, so this stays fast on
// thousands of rows (checking every row against every other froze the page).
export function uniqueObjects(rows = []) {
  const seen = new Set();
  return rows.filter((row) => {
    const key = JSON.stringify(row);
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
